import { component as defineComponent } from 'flightjs';

export default defineComponent(function () {
    this.attributes({
        filterNameAttr: 'data-button-group-filter',
        button: '[data-button-group-filter-button]',
        filterOptionItem: '[data-button-group-filter-button]',
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);
        this.on('click', {
            button: this.triggerBrowseFiltersUpdated,
        });
    });

    this.triggerBrowseFiltersUpdated = function (e) {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var item = $(e.currentTarget);
        var value = item.attr('data-value');
        var payload = {};

        e.preventDefault();

        if ($(e.currentTarget).attr('data-disabled')) {
            return;
        }

        if (this.$node.data('filterValue') !== value) {
            this.$node.data('filterValue', value);
            payload[fieldName] = value;
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.updateDisplay = function (e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);
        var value;

        if (data.hasOwnProperty(field)) {
            value = data[field];
            this.$node.data('filterValue', value);

            this.select('filterOptionItem').each(function () {
                if ($(this).attr('data-value') === value) {
                    $(this).attr('data-button-selected', 1);
                } else {
                    $(this).removeAttr('data-button-selected');
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/button-group-filter.js